import { createAction } from 'redux-actions';
import SwaggerAPI from 'data/SwaggerAPI';
import _ from 'lodash';
import { PlanHelpers } from 'utils';

const REQUEST_EVENTS = 'events/REQUEST_EVENTS';
const CREATE_EVENT = 'events/CREATE_EVENT';
const MODIFY_EVENT = 'events/MODIFY_EVENT';
const EVENT_BATCH_UPDATE = 'events/EVENT_BATCH_UPDATE';
const DELETE_EVENT = 'events/DELETE_EVENT';

const MODIFY_PLAN = 'events/MODIFY_PLAN';

const CLEAR_PLAN = 'events/CLEAR_PLAN';
const CLEAR_FILTER = 'events/CLEAR_FILTER';
const SET_FILTER = 'events/SET_FILTER';
const RECEIVE_EVENTS = 'events/RECEIVE_EVENTS';
const RECEIVE_EVENTS_COUNT = 'events/RECEIVE_EVENTS_COUNT';

const SET_EVENT_DETAILS = 'events/SET_EVENT_DETAILS';
const SET_SHOW_ARCHIVE = 'events/SET_SHOW_ARCHIVE';

const initialState = {
  isFetchingEvents: false,
  events: {},
  filters: {
    type: '',
    layer: '',
    layer_id: '',
    time_start: '',
    time_end: '',
    search: '',
    organization_id: '',
    orderBy: 'time',
    order: 'asc',
  },
  eventsCount: 0,
  farmerPlan: { layer_id: 'None', type: 'None', time: new Date(), data: {} },
  specialDisplay: {},
  planValid: { generalValid: false, specialValid: false },
  showEventDetails: false,
  showArchive: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_EVENTS: {
      return { ...state, isFetchingEvents: true };
    }
    case MODIFY_PLAN: {
      const newPlan = Object.assign({}, state.farmerPlan, action.payload);
      const valid = PlanHelpers.validatePlan(newPlan);

      return {
        ...state,
        farmerPlan: newPlan,
        planValid: valid,
      };
    }
    case MODIFY_EVENT: {
      const eventsCopy = _.clone(state.events);
      const event = action.payload[0];
      if (event) {
        let layerKey;
        let eventIndex;
        _.forEach(eventsCopy, (layer, key) => {
          const matchInLayer = _.findIndex(layer, { id: event.id });
          if (matchInLayer > -1) {
            eventIndex = matchInLayer;
            layerKey = key;
          }
        });

        if (layerKey && eventIndex > -1) {
          eventsCopy[layerKey][eventIndex] = event;
        }
      }

      return {
        ...state,
        events: eventsCopy,
        isFetchingEvents: false,
      };
    }
    case CREATE_EVENT: {
      const eventsCopy = _.clone(state.events);
      const event = action.payload;
      if (event) {
        if (!eventsCopy[event.layer_id]) {
          eventsCopy[event.layer_id] = [event];
        } else {
          eventsCopy[event.layer_id] = eventsCopy[event.layer_id].concat(event);
        }
      }

      return {
        ...state,
        events: eventsCopy,
        isFetchingEvents: false,
      };
    }
    case EVENT_BATCH_UPDATE: {
      const eventsCopy = _.clone(state.events);

      _.forEach(action.payload, (updatedEvent) => {
        _.forEach(eventsCopy, (layer) => {
          if (_.find(layer, { id: updatedEvent.id })) {
            _.remove(layer, { id: updatedEvent.id });
            layer.push(updatedEvent);
          }
        });
      });

      return {
        ...state,
        events: eventsCopy,
        isFetchingEvents: false,
      };
    }
    case DELETE_EVENT: {
      return {
        ...state,
        isFetchingEvents: false,
      };
    }
    case RECEIVE_EVENTS: {
      if (action.payload.length == 0) {
        return { ...state, events: {}, isFetchingEvents: false };
      }

      const eventsByLayer = {};

      _.forEach(action.payload, (event) => {
        if (!eventsByLayer[event.layer_id]) {
          eventsByLayer[event.layer_id] = [event];
        } else {
          eventsByLayer[event.layer_id] = eventsByLayer[event.layer_id].concat(event);
        }
      });

      return {
        ...state,
        events: eventsByLayer,
        isFetchingEvents: false,
      };
    }
    case SET_FILTER: {
      const currentFilters = { ...state.filters };
      const newFilters = Object.assign({}, currentFilters, action.payload);
      return {
        ...state,
        filters: newFilters,
      };
    }
    case CLEAR_FILTER: {
      const clearFilter = {};
      return {
        ...state,
        filters: clearFilter,
      };
    }
    case CLEAR_PLAN: {
      return {
        ...state,
        farmerPlan: {
          layer_id: 'None',
          type: 'None',
          time: new Date(),
          data: {},
        },
        planValid: { generalValid: false, specialValid: false },
      };
    }

    case RECEIVE_EVENTS_COUNT: {
      return {
        ...state,
        eventsCount: Object.assign({}, state.eventsCount, action.payload.count_map),
        isFetchingEvents: false,
      };
    }
    case SET_EVENT_DETAILS: {
      return {
        ...state,
        showEventDetails: action.view,
      };
    }
    case SET_SHOW_ARCHIVE: {
      return {
        ...state,
        showArchive: action.payload,
      };
    }
    default:
      return state;
  }
};

export const Events = (function () {
  const startFetch = () => ({ type: REQUEST_EVENTS });
  const createEvent = createAction(CREATE_EVENT, SwaggerAPI.eventCreate);
  const editEvent = createAction(MODIFY_EVENT, SwaggerAPI.eventUpdate);
  const eventBatchUpdate = createAction(EVENT_BATCH_UPDATE, SwaggerAPI.eventBatchUpdate);
  const deleteEvent = createAction(DELETE_EVENT, SwaggerAPI.eventDelete);

  const modifyPlan = (plan) => ({ type: MODIFY_PLAN, payload: plan });

  const clearPlan = () => ({ type: CLEAR_PLAN });
  const clearFilter = () => ({ type: CLEAR_FILTER });
  const setFilter = (filter) => ({ type: SET_FILTER, payload: filter });
  const fetchEvents = createAction(RECEIVE_EVENTS, SwaggerAPI.eventQuery);
  const fetchEventsCount = createAction(RECEIVE_EVENTS_COUNT, SwaggerAPI.eventCountQuery);
  const setShowEventDetails = (view) => ({ type: SET_EVENT_DETAILS, view });
  const setShowArchive = (showArchive) => ({ type: SET_SHOW_ARCHIVE, payload: showArchive });

  const getEvents = (state) => {
    return state.events.events;
  };
  const getEventsCount = (state) => {
    return state.events.eventsCount;
  };
  const getIsFetchingEvents = (state) => {
    return state.events.isFetchingEvents;
  };
  const getPlanIsValid = (state) => {
    return state.events.planValid;
  };
  const getPlanSpecialDisplay = (state) => {
    return state.events.specialDisplay;
  };

  const getFarmerPlan = (state) => {
    return state.events.farmerPlan;
  };
  const getFilters = (state) => {
    return state.events.filters;
  };
  const getCurrentPanel = (state) => {
    return state.events.currentPanel;
  };

  const getShowEventDetails = (state) => {
    return state.events.showEventDetails;
  };
  const getShowArchive = (state) => {
    return state.events.showArchive;
  };
  return {
    startFetch,
    createEvent,
    editEvent,
    eventBatchUpdate,
    deleteEvent,
    fetchEvents,
    fetchEventsCount,
    setShowEventDetails,
    setShowArchive,
    getEvents,
    getEventsCount,
    getIsFetchingEvents,
    setFilter,
    clearFilter,
    modifyPlan,
    clearPlan,
    getFarmerPlan,
    getCurrentPanel,
    getShowEventDetails,
    getPlanIsValid,
    getPlanSpecialDisplay,
    getFilters,
    getShowArchive,
  };
})();
